// namespace (소문자)
export const NAMESPACE = 'community';

//getters
export const HOT_LIST = 'HOT_LIST';
export const BOARD = 'BOARD';
export const BOARD_LIST = 'BOARD_LIST';
export const FETCH_BOARD_CNT = 'FETCH_BOARD_CNT';
export const FETCH_BOARD_REPLY_LIST_MINE = 'FETCH_BOARD_REPLY_LIST_MINE';
export const BOARD_REPLY_LIST = 'BOARD_REPLY_LIST';
export const KNOWHOW = 'KNOWHOW';
export const KNOWHOW_LIST = 'KNOWHOW_LIST';
export const FETCH_KNOWHOW_CNT = 'FETCH_KNOWHOW_CNT';
export const KNOWHOW_ANSWER_LIST = 'KNOWHOW_ANSWER_LIST';
export const KNOWHOW_REPLY_LIST = 'KNOWHOW_REPLY_LIST';
export const FETCH_KNOWHOW_REPLY_LIST_MINE = 'FETCH_KNOWHOW_REPLY_LIST_MINE';
export const HOT_POST_LIST = 'HOT_POST_LIST';

//actions
// 자유게시판
export const FETCH_BOARD = 'FETCH_BOARD';
export const FETCH_BOARD_LIST = 'FETCH_BOARD_LIST';
export const CREATE_BOARD = 'CREATE_BOARD';
export const UPDATE_BOARD = 'UPDATE_BOARD';
export const DELETE_BOARD = 'DELETE_BOARD';
export const LIKE_BOARD = 'LIKE_BOARD';
export const UNLIKE_BOARD = 'UNLIKE_BOARD';
export const REPORT_BOARD = 'REPORT_BOARD';

export const FETCH_BOARD_REPLY_LIST = 'FETCH_BOARD_REPLY_LIST';
export const CREATE_BOARD_REPLY = 'CREATE_BOARD_REPLY';
export const UPDATE_BOARD_REPLY = 'UPDATE_BOARD_REPLY';
export const DELETE_BOARD_REPLY = 'DELETE_BOARD_REPLY';
export const LIKE_BOARD_REPLY = 'LIKE_BOARD_REPLY';
export const UNLIKE_BOARD_REPLY = 'UNLIKE_BOARD_REPLY';
export const REPORT_BOARD_REPLY = 'REPORT_BOARD_REPLY';

// 지식인
export const FETCH_KNOWHOW = 'FETCH_KNOWHOW';
export const FETCH_KNOWHOW_LIST = 'FETCH_KNOWHOW_LIST';
export const FETCH_KNOWHOW_ANSWER_LIST = 'FETCH_KNOWHOW_ANSWER_LIST';
export const FETCH_KNOWHOW_ANSWER_DETAIL = 'FETCH_KNOWHOW_ANSWER_DETAIL';
export const CREATE_KNOWHOW = 'CREATECREATE_KNOWHOWBOARD';
export const CREATE_KNOWHOW_ANSWER = 'CREATE_KNOWHOW_ANSWER';
export const UPDATE_KNOWHOW = 'UPDATE_KNOWHOW';
export const DELETE_KNOWHOW = 'DELETE_KNOWHOW';
export const LIKE_KNOWHOW = 'LIKE_KNOWHOW';
export const UNLIKE_KNOWHOW = 'UNLIKE_KNOWHOW';
export const REPORT_KNOWHOW = 'REPORT_KNOWHOW';

export const FETCH_KNOWHOW_REPLY_LIST = 'FETCH_KNOWHOW_REPLY_LIST';
export const CREATE_KNOWHOW_REPLY = 'CREATE_KNOWHOW_REPLY';
export const UPDATE_KNOWHOW_REPLY = 'UPDATE_KNOWHOW_REPLY';
export const DELETE_KNOWHOW_REPLY = 'DELETE_KNOWHOW_REPLY';
export const LIKE_KNOWHOW_REPLY = 'LIKE_KNOWHOW_REPLY';
export const UNLIKE_KNOWHOW_REPLY = 'UNLIKE_KNOWHOW_REPLY';
export const REPORT_KNOWHOW_REPLY = 'REPORT_KNOWHOW_REPLY';

export const FETCH_HOT_LIST = 'FETCH_HOT_LIST';
export const REPORT_USER = 'REPORT_USER';

export const FETCH_HOT_POST_LIST = 'FETCH_HOT_POST_LIST';

//mutations
export const SET_HOT_LIST = 'SET_HOT_LIST';
export const SET_BOARD = 'SET_BOARD';
export const SET_BOARD_LIST = 'SET_BOARD_LIST';
export const SET_BOARD_REPLY_LIST = 'SET_BOARD_REPLY_LIST';
export const SET_BOARD_REPLY_LIST_MINE = 'SET_BOARD_REPLY_LIST_MINE';

export const SET_KNOWHOW = 'SET_KNOWHOW';
export const SET_KNOWHOW_LIST = 'SET_KNOWHOW_LIST';
export const SET_KNOWHOW_ANSWER_LIST = 'SET_KNOWHOW_ANSWER_LIST';
export const SET_KNOWHOW_ANSWER_DETAIL = 'SET_KNOWHOW_ANSWER_DETAIL';
export const SET_KNOWHOW_REPLY_LIST = 'SET_KNOWHOW_REPLY_LIST';
export const SET_KNOWHOW_REPLY_LIST_MINE = 'SET_KNOWHOW_REPLY_LIST_MINE';

export const SET_HOT_POST_LIST = 'SET_HOT_POST_LIST';
